$(".swtches-custom-class").click(function (t) {
  t.preventDefault();
}),
  $(".color-button").click(function (t) {
    t.preventDefault();
    const o = $(this),
      e = o
        .parent()
        .siblings(".product-tile")
        .find(".product-quick-add-to-cart--with-size-option"),
      i = o.data().product,
      c = o.data().color;
    let r =
      '<button type="button" class="js-custom-quickbuy-button font-family-heading text-xxs py-3 px-5 uppercase leading-loose border border-solid tracking-widest focus-visible:outline-none transition-[color,background-color,opacity] focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange focus-visible:outline-offset-2 text-white border-black bg-black hover:text-black hover:bg-white focus-visible:text-black focus-visible:bg-white w-full js-product-quick-add-to-cart-button block">Quick buy</button><div class="js-custom-quickbuy-options-buttons transition-opacity flex-row flex-wrap justify-center content-center mx-[0.3125rem] w-full js-product-quick-add-to-cart-size-selector opacity-0 hidden">';
    const s = i.options.indexOf("Size");
    s >= 0 &&
      (i.variants.forEach((t) => {
        t.available
          ? (r += `<div class="px-[0.3125rem] mt-[0.625rem]"><button type="button" data-varaintid = ${t.id} class="custom-quick-add-to-cart-option block min-w-[2rem] h-8 lg:min-w-[2.75rem] lg:h-11 px-3 border border-black uppercase text-black bg-white text-center hover:text-white hover:bg-black focus-visible:text-white focus-visible:bg-black js-product-quick-add-to-cart-size-selector-button" data-value="${t.options[s]}">${t.options[s]}</button></div>`)
          : (r += `<div class="px-[0.3125rem] mt-[0.625rem]"><button type="button" disabled="" class="block min-w-[2rem] h-8 lg:min-w-[2.75rem] lg:h-11 px-3 border border-black uppercase text-black bg-white text-center cursor-not-allowed line-through js-product-quick-add-to-cart-size-selector-button" data-value="${t.options[s]}">${t.options[s]}</button></div>`);
      }),
      (r += "</div>"),
      e.html(r)),
      $(".color-button").removeClass("add_switches_border"),
      o.addClass("add_switches_border"),
      o.parent().siblings(".selected-product-color").length > 0
        ? o.parent().siblings(".selected-product-color").html(c)
        : o
            .parent()
            .siblings(".product-tile")
            .find(".selected-product-color")
            .html(c);
    const a = o.parent().siblings(".product-tile").find("img");
    console.log(o.data("imageurl"), o.data("hoverimageurl")),
      a.eq(0).attr("src", o.data("imageurl")),
      a.eq(1).attr("src", o.data("hoverimageurl"));
  }),
  $(document).on("click", ".custom-quick-add-to-cart-option", function (t) {
    t.preventDefault();
    const o = $(this);
    var e = { items: [{ id: Number(o.data("varaintid")), quantity: 1 }] };
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(e),
    })
      .then((t) => {
        t.ok
          ? (document.dispatchEvent(new CustomEvent("refreshShoppingCart")),
            document.dispatchEvent(new CustomEvent("openShoppingCart")))
          : console.error("Failed to add to cart:", t.statusText);
      })
      .catch((t) => {
        console.error("Network error:", t);
      });
  }),
  setInterval(function () {
    $(".product-tile").each(function (t, o) {
      const e = $(o).find(".js-product-quick-add-to-cart-button"),
        i = $(o).find(".js-product-quick-add-to-cart-size-selector");
      e.length > 1 &&
        e.each(function (t, o) {
          $(o).hasClass("js-custom-quickbuy-button") ||
            ($(o).remove(), i[t].remove());
        });
    });
  }, 500);
